import { PhStudent, PhArrowLineRight, PhUsers, PhGlobeStand } from '@phosphor-icons/vue'
import type { RouteRecordRaw } from 'vue-router'

const schoolAdminRoutesNames = {
  schoolAdminStudents: 'schoolAdminStudents',
  schoolAdminTransferStudents: 'schoolAdminTransferStudents',
  schoolAdminStudentsList: 'schoolAdminStudentsList',
  schoolAdminStudentsImport: 'schoolAdminStudentsImport',
  schoolAdminStudentsImportStatus: 'schoolAdminStudentsImportStatus',
  schoolAdminEditStudent: 'schoolAdminEditStudent',
  schoolAdminCreateStudent: 'schoolAdminCreateStudent',
  schoolAdminDirectory: 'schoolAdminDirectory',
  schoolAdminDirectoryDetails: 'schoolAdminDirectoryDetails',
  schoolAdminDirectoryImport: 'schoolAdminDirectoryImport',
  schoolAdminDirectoryImportStatus: 'schoolAdminDirectoryImportStatus',
  schoolAdminGroups: 'schoolAdminGroups',
  schoolAdminGroupStudents: 'schoolAdminGroupStudents',
  schoolAdminGroupStudent: 'schoolAdminGroupStudent',
  schoolAdminTransferStudentsOutcoming: 'schoolAdminTransferStudentsOutcoming',
  schoolAdminTransferStudentsIncoming: 'schoolAdminTransferStudentsIncoming'
}

const schoolAdminRoutes: RouteRecordRaw[] = [
  {
    path: 'students',
    name: schoolAdminRoutesNames.schoolAdminStudents,
    meta: {
      label: 'Students',
      icon: PhStudent
    },
    redirect: { name: schoolAdminRoutesNames.schoolAdminStudentsList },
    component: () => import('@/layouts/RouterTabsLayout.vue'),
    children: [
      {
        path: 'list',
        name: schoolAdminRoutesNames.schoolAdminStudentsList,
        component: () => import('@/features/students/StudentsList.vue'),
        meta: {
          parentName: schoolAdminRoutesNames.schoolAdminStudents,
          label: 'Students',
          icon: PhStudent,
          routeTestId: 'school-admin-students-list'
        }
      },
      {
        path: 'transfer-students',
        name: schoolAdminRoutesNames.schoolAdminTransferStudents,
        component: () => import('@/views/school-admin/students/SchoolAdminTransferStudents.vue'),
        meta: {
          parentName: schoolAdminRoutesNames.schoolAdminStudents,
          label: 'Transfer students',
          icon: PhArrowLineRight,
          routeTestId: 'school-admin-transfer-students'
        },
        redirect: { name: schoolAdminRoutesNames.schoolAdminTransferStudentsIncoming },
        children: [
          {
            path: 'incoming',
            name: schoolAdminRoutesNames.schoolAdminTransferStudentsIncoming,
            component: () => import('@/views/school-admin/students/IncomingTransferStudents.vue'),
            meta: {
              parentName: schoolAdminRoutesNames.schoolAdminTransferStudents,
              label: 'Incoming requests'
            }
          },
          {
            path: 'outgoing',
            name: schoolAdminRoutesNames.schoolAdminTransferStudentsOutcoming,
            component: () => import('@/views/school-admin/students/OutcomingTransferStudents.vue'),
            meta: {
              parentName: schoolAdminRoutesNames.schoolAdminTransferStudents,
              label: 'Outgoing requests'
            }
          }
        ]
      }
    ]
  },
  {
    path: 'students/import',
    name: schoolAdminRoutesNames.schoolAdminStudentsImport,
    meta: {
      parentName: schoolAdminRoutesNames.schoolAdminStudents,
      notRenderInSidebar: true,
      routeKey: 'students'
    },
    component: () => import('@/views/school-admin/import/SchoolAdminImport.vue')
  },
  {
    path: 'students/import/:id',
    name: schoolAdminRoutesNames.schoolAdminStudentsImportStatus,
    meta: {
      notRenderInSidebar: true,
      routeKey: 'students'
    },
    component: () => import('@/views/school-admin/import/SchoolAdminImportStatus.vue')
  },
  {
    path: 'students/list/:id',
    name: schoolAdminRoutesNames.schoolAdminEditStudent,
    meta: {
      notRenderInSidebar: true
    },
    component: () => import('@/views/school-admin/students/SchoolAdminStudentDetails.vue')
  },
  {
    path: 'students/list/create',
    name: schoolAdminRoutesNames.schoolAdminCreateStudent,
    meta: {
      notRenderInSidebar: true
    },
    component: () => import('@/views/school-admin/students/SchoolAdminStudentDetails.vue')
  },
  {
    path: 'directory',
    name: schoolAdminRoutesNames.schoolAdminDirectory,
    meta: {
      label: 'Directory',
      icon: PhUsers,
      routeTestId: 'school-admin-directory-list-tab'
    },
    component: () => import('@/views/school-admin/directory/SchoolAdminDirectoryList.vue')
  },
  {
    path: 'directory/add',
    name: schoolAdminRoutesNames.schoolAdminDirectoryDetails,
    meta: {
      notRenderInSidebar: true
    },
    component: () => import('@/views/school-admin/directory/SchoolAdminDirectoryDetails.vue')
  },
  {
    path: 'directory/import',
    name: schoolAdminRoutesNames.schoolAdminDirectoryImport,
    meta: {
      parentName: schoolAdminRoutesNames.schoolAdminDirectory,
      notRenderInSidebar: true,
      routeKey: 'directory'
    },
    component: () => import('@/views/school-admin/import/SchoolAdminImport.vue')
  },
  {
    path: 'directory/import/:id',
    name: schoolAdminRoutesNames.schoolAdminDirectoryImportStatus,
    meta: {
      notRenderInSidebar: true,
      routeKey: 'directory'
    },
    component: () => import('@/views/school-admin/import/SchoolAdminImportStatus.vue')
  },
  {
    path: 'groups',
    name: schoolAdminRoutesNames.schoolAdminGroups,
    meta: {
      label: 'Groups',
      icon: PhGlobeStand,
      routeTestId: 'school-admin-groups-list-tab'
    },
    component: () => import('@/features/groups/GroupsManagement.vue')
  },
  {
    path: 'groups/:id',
    name: schoolAdminRoutesNames.schoolAdminGroupStudents,
    meta: {
      parentName: schoolAdminRoutesNames.schoolAdminGroups,
      notRenderInSidebar: true
    },
    component: () => import('@/features/groups/GroupStudents.vue')
  }
]

export {
  schoolAdminRoutesNames,
  schoolAdminRoutes
}
